<template>
  <div class="file-upload">
    <AppFileDragDrop
      v-model="files"
      @error="showErrors"
    />

    <div class="file-upload__actions">
      <v-btn
        depressed
        color="primary"
        :loading="isFormProcessing"
        :disabled="isUploadCompleted || !files.length"
        @click="submitFiles"
      >
        Dodaj pliki
      </v-btn>
      <v-btn
        v-if="isUploadCompleted"
        depressed
        color="secondary"
        @click="clearForm"
      >
        Dodaj kolejne
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AppFileDragDrop from '@/components/UI/AppFileDragDrop.vue';

export default {
  components: {
    AppFileDragDrop,
  },

  props: {
    kiwFile: {
      type: Boolean,
      default: false,
    },
    commercialPrintFile: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isFormProcessing: false,
      isUploadCompleted: false,
      files: [],
    };
  },

  computed: {
    allUploadsCompleted() {
      return !!this.files.length && this.files.every((file) => file.status === 'uploaded' || file.status === 'error');
    },
  },

  watch: {
    allUploadsCompleted(status) {
      if (status) {
        this.isFormProcessing = false;
        this.isUploadCompleted = true;
      }
    },
  },

  methods: {
    ...mapActions('project', ['uploadProjectFile']),
    ...mapActions('kiwSingle', ['uploadKIWFile']),
    ...mapActions('commercialPrintSingle', ['uploadCommercialPrintFile']),
    ...mapActions('snackbar', ['showSnackbar']),

    showErrors(errors) {
      this.showSnackbar({
        message: errors,
        type: 'error',
      });
    },

    submitFiles() {
      this.isFormProcessing = true;

      this.files.forEach((file, i) => {
        const formData = new FormData();
        formData.append('file', file.data);
        this.files[i].status = 'processing';

        let uploadFunction;

        switch (true) {
          case this.kiwFile:
            uploadFunction = 'uploadKIWFile';
            break;
          case this.commercialPrintFile:
            uploadFunction = 'uploadCommercialPrintFile';
            break;
          default:
            uploadFunction = 'uploadProjectFile';
        }

        this[uploadFunction](formData)
          .then(() => {
            this.files[i].status = 'uploaded';
          })
          .catch(() => {
            this.files[i].status = 'error';
          });
      });
    },

    clearForm() {
      this.files.splice(0, this.files.length);
      this.isUploadCompleted = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.file-upload {
  display: block;

  &__actions {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
  }
}
</style>
